export default class VacationTableItem {
    vacationId = 0;
    vacationStatus = 0;
    vacationName = "";
    vacationCompany = "";
    vacationDdId = "";
    createName = "";
    createTime = "";
    modifyName = "";
    modifyTime = "";
}
